import { createStyles } from 'antd-style';

import {
  ThemeColors,
  ThemeFont,
  ThemeSpaces,
  hexToRgbaWithAlpha,
} from '../../theme';
import { borderRadius, listCard, spaceBetween } from '../../styles/mixins';

export const useActivityIndicatorsStyles = createStyles(({ token }) => ({
  activityIndicators: {
    display: 'flex',
    alignItems: 'flex-start',
    color: ThemeColors.COLOR_GREY7_6,
    height: '100%',
    paddingTop: token.paddingXS,
  },
  activityIndicatorsIndicator: {
    ...spaceBetween(ThemeSpaces.SPACE_NORM, 'horizontal'),

    '&.highlight': {
      color: ThemeColors.COLOR_BLUE2,
    },
    '&.orange': {
      color: ThemeColors.COLOR_ORANGE4,
    },
  },
  activityIndicatorsIcon: {
    fontSize: token.fontSizeLG,
  },
}));

export const useMonitorJobListStyles = createStyles(({ token }) => ({
  monitorJobList: {
    padding: `${ThemeSpaces.SPACE_NORM0_5}px 0 ${ThemeSpaces.SPACE_NORM}px 0`,
  },
  monitorJobListContainer: {
    display: 'flex',
    height: '100%',
  },
  monitorJobListItem: {
    position: 'relative',
    ...listCard(token),
    display: 'block',
    padding: `${ThemeSpaces.SPACE_SM}px ${ThemeSpaces.SPACE_NORM}px`,

    '&.CardDisabled': {
      '&.monitor-job-list-item-sm .monitor-job-list-column:not(:nth-child(2)), &.monitor-job-list-item-md .ant-col:not(:last-child), &.monitor-job-list-item-lg .ant-col:not(:last-child)':
        {
          opacity: 0.6,
          cursor: 'default',
        },
    },

    '.monitor-job-list-item-content': {
      display: 'flex',
      height: '100%',
    },

    '&.monitor-job-list-item-with-top-bar .monitor-job-list-item-content': {
      paddingTop: ThemeSpaces.SPACE_MD,
    },

    '&.monitor-job-list-item-sm': {
      height: 150,

      '&.monitor-job-list-item-with-top-bar': {
        height: 162,
      },

      '.monitor-job-list-item-content': {
        flexWrap: 'wrap',

        '.monitor-job-list-column': {
          marginBottom: 6,
          marginRight: ThemeSpaces.SPACE_MD,

          '&:nth-child(odd)': {
            width: '55%',
            maxWidth: '55%',
            flex: 'auto',
          },
          '&:nth-child(even)': {
            flex: 1,
            overflow: 'hidden',
            marginRight: 0,
          },
          '&:last-child, &:nth-last-child(2)': {
            marginBottom: 0,
          },
        },
      },
    },
    '&.monitor-job-list-item-md': {
      height: 80,

      '&.monitor-job-list-item-with-top-bar': {
        height: 92,
      },

      '.monitor-job-list-item-content': {
        '> .ant-row': {
          flex: '1 1 auto',
          minWidth: 0,

          '> .ant-col': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            flex: 1,
            minWidth: 0,
          },

          '> .ant-col:nth-child(1), .ant-col:nth-child(2)': {
            flex: 1.3,
          },

          '> .ant-col:nth-child(4)': {
            flex: 1.2,
          },
        },
      },
    },
    '&.monitor-job-list-item-lg': {
      height: 70,

      '&.monitor-job-list-item-with-top-bar': {
        height: 82,
      },

      '.monitor-job-list-item-content': {
        '> .ant-row': {
          flex: '1 1 auto',
          minWidth: 0,

          '> .ant-col': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            flex: 1,
            minWidth: 0,
          },
        },
      },

      '.monitor-job-list-label': {
        fontSize: ThemeFont.FONT_SIZE_XS,
        fontWeight: 'normal',
      },
    },
  },
  monitorJobListTopBar: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: 12,
    lineHeight: '13px',
    backgroundColor: hexToRgbaWithAlpha(ThemeColors.COLOR_BLUE2, 0.65),
    color: token.colorWhite,
    fontSize: ThemeFont.FONT_SIZE_XS,
    fontWeight: 900,
    fontStyle: 'italic',
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    ...borderRadius({ size: token.borderRadiusSM, side: 'top' }),
  },
  monitorJobListColumn: {
    display: 'flex',
    flexDirection: 'column',
  },
  monitorJobListLabel: {
    fontSize: ThemeFont.FONT_SIZE_XXS,
    fontWeight: 500,
    lineHeight: 1,
    textTransform: 'uppercase',
    color: ThemeColors.COLOR_GREY_BLUISH,
  },
  monitorJobListLabelCopyIcon: {
    '> *': {
      paddingRight: 0,
    },
  },
  monitorJobListContent: {
    flex: 1,
    color: ThemeColors.COLOR_GREY3,
    fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    fontWeight: 500,
    lineHeight: '16px',
    whiteSpace: 'pre',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}));
